// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__2LMmW","content":"Desktop_content__2JSxQ"};